import { characterActions } from "@dndbeyond/character-rules-engine/es";

import type { CharacterActionMapper } from "../middleware";

type ClassAddRequestAction = ReturnType<
  typeof characterActions.classAddRequest
>;

/**
 * Choosing a class in the builder, including adding a multiclass
 */
export const mapClassAdd: CharacterActionMapper<ClassAddRequestAction> = (
  action
) => {
  const { charClass } = action.payload;

  return {
    changeCategory: "CLASS",
    changeDescriptors: [
      {
        changeType: "select",
        itemId: charClass.id,
        newValue: charClass.name ?? undefined,
      },
    ],
  };
};
